import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";
import VueAxios from "vue-axios";
import _accessApi from "@/router/_accessApi.js";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
//const DashboardOld = () => import('@/views/Dashboard')

const Dashboard = () => import('@/views/dashboard/Dashboard')

// Page Master
const User = () => import('@/views/master/users/User')
const UserDetail = () => import('@/views/master/users/UserDetail')
const Delivery = () => import('@/views/master/delivery/Delivery')
const DeliveryDetail = () => import('@/views/master/delivery/DeliveryDetail')
const HomeVideo = () => import('@/views/master/home_video/HomeVideo')
const Faq = () => import('@/views/master/faq/Faq')
const ContactUs = () => import('@/views/master/contact_us/ContactUs')
const ContactUsDetail = () => import("@/views/master/contact_us/ContactUsDetail");
const ProductCategory = () => import('@/views/master/product_category/ProductCategory')
const ProductCategoryDetail = () => import('@/views/master/product_category/ProductCategoryDetail')
const MenuAccess = () => import('@/views/master/menu_access/MenuAccess')
const TermCondition = () => import('@/views/master/term_condition/TermCondition')
const AddMenu = () => import('@/views/master/add_menu/AddMenu')
const Question = () => import('@/views/master/question/Question')

// forgot password
const ChangePassword = () => import('@/views/change_password/ChangePassword')

// Page Products
const Products = () => import('@/views/product/products/Products')
const ProductsDetail = () => import('@/views/product/products/ProductsDetail')

const ProductIssue = () => import('@/views/product/issue/ProductIssue')
const ProductIssueDetail = () => import('@/views/product/issue/ProductIssueDetail')

// Page Freezer
const Freezers = () => import('@/views/freezer/freezers/Freezers')
const FreezersDetail = () => import('@/views/freezer/freezers/FreezersDetail')

// Page Owner Freezer
const OwnerFreezer = () => import('@/views/master/owner_freezer/OwnerFreezer')
const OwnerFreezerDetail = () => import('@/views/master/owner_freezer/OwnerFreezerDetail')

// Page Administrator
const Administrator = () => import('@/views/administrator/Administrator')
const AdministratorDetail = () => import('@/views/administrator/AdministratorDetail')

const Privacy = () => import('@/views/privacy/Privacy')


// Page Dropdown
const AgentStatus = () => import('@/views/master/dropdown/AgentStatus')
const OrderStatus = () => import('@/views/master/dropdown/OrderStatus')
const PaymentMethod = () => import('@/views/master/dropdown/PaymentMethod')
const PaymentMethodDetail = () => import('@/views/master/dropdown/PaymentMethodDetail')
const ProductIssueType = () => import('@/views/master/dropdown/ProductIssueType')
const ProductStatus = () => import('@/views/master/dropdown/ProductStatus')
const ProductGroup = () => import('@/views/master/dropdown/ProductGroup')
const NotificationType = () => import('@/views/master/dropdown/NotificationType')
const VoucherGroup = () => import('@/views/master/dropdown/VoucherGroup')
const Community = () => import('@/views/master/dropdown/Community')
const ComplaintType = () => import('@/views/master/dropdown/ComplaintType')
const Villages = () => import('@/views/master/dropdown/Villages')
const District = () => import('@/views/master/dropdown/District')
const Regencies = () => import('@/views/master/dropdown/Regencies')
const Province = () => import('@/views/master/dropdown/Province')
const Religion = () => import('@/views/master/dropdown/Religion')
const UserType = () => import('@/views/master/dropdown/UserType')
const UserGroup = () => import('@/views/master/dropdown/UserGroup')

const DeliveryStatus = () => import('@/views/master/dropdown/DeliveryStatus')
const DeliveryTypeStatus = () => import('@/views/master/dropdown/DeliveryTypeStatus')
const ProductUnit = () => import('@/views/master/dropdown/ProductUnit')

const PartnershipGroup = () => import("@/views/master/partnership_group/PartnershipGroup");
const PartnershipGroupDetail = () => import("@/views/master/partnership_group/PartnershipGroupDetail");

const Notification = () => import('@/views/notification/Notification')
const NotificationDetail = () => import('@/views/notification/NotificationDetail')

const ConfirmationPayment = () => import('@/views/payment/confirmation_payment/ConfirmationPayment')
const ConfirmationPaymentDetail = () => import('@/views/payment/confirmation_payment/ConfirmationPaymentDetail')

const VoucherClaim = () => import('@/views/voucher_claim/VoucherClaim')


// Page Order
const Order = () => import('@/views/order/Order')
const OrderDetail = () => import('@/views/order/OrderDetail')

// Page Complaint
const Complaint = () => import("@/views/complaint/Complaint");
const ComplaintDetail = () => import("@/views/complaint/ComplaintDetail");

//Page Partnership
const Partnership = () => import("@/views/partnership/Partnership");
const PartnershipDetail = () => import("@/views/partnership/PartnershipDetail");

// Page Cancel Order
const CancelOrder = () => import("@/views/cancel_order/CancelOrder");
const CancelOrderDetail = () => import("@/views/cancel_order/CancelOrderDetail");


// Page Voucher
const Voucher = () => import("@/views/voucher/Voucher");
const VoucherDetail = () => import("@/views/voucher/VoucherDetail");

// Page Promotion
const Promotion = () => import("@/views/promotion/Promotion");
const PromotionDetail = () => import("@/views/promotion/PromotionDetail");

// Page News
const News = () => import("@/views/news/News");
const NewsDetail = () => import("@/views/news/NewsDetail");

// Page Export
const ExportOrder = () => import("@/views/exports/Order");
const ExportProduct = () => import("@/views/exports/Product");
const ExportAgent = () => import("@/views/exports/Agent_information")
const ExportFreezerRequest = () => import("@/views/exports/Freezer_request")

// Page User Request Freezer
const UserRequestFreezer = () => import("@/views/request_freezer/UserRequestFreezer")
const UserRequestFreezerDetail = () => import("@/views/request_freezer/UserRequestFreezerDetail")

// // Views - Pages
const Page404 = () => import('@/views/default/pages/Page404')
// const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/login/Login')
const ForgotPassword = () => import('@/views/login/ForgotPassword')

//pages
const MasterAgent = () => import('@/views/master/agent/Agent')
const MasterAgentDetail = () => import('@/views/master/agent/AgentDetail')

const VideoEducation = () => import('@/views/master/video_education/VideoEducation')
const VideoEducationCategory = () => import('@/views/master/video_education/VideoEducationCategory')


Vue.use(Router)

export const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes() {
  return [
    { path: "*", component: Page404 },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/forgot-password",
      name: "Forgot Password",
      component: ForgotPassword,
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "notification",
          redirect: "/notification/notification",
          name: "Notification",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "notification",
              name: "Notifications",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Notification,
                },
                {
                  path: "detail/:id",
                  name: "Notification Details",
                  component: NotificationDetail,
                },
              ],
            },
          ],
        },
        {
          path: "payment",
          redirect: "/payment/confirmation_payment",
          name: "Payment",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "confirmation_payment",
              redirect: "/payment/confirmation_payment",
              name: "Confirmation Payment",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ConfirmationPayment,
                },
                {
                  path: "detail/:id",
                  name: "Confirmation Payment Details",
                  component: ConfirmationPaymentDetail,
                },
              ],
            },
          ],
        },

        {
          path: "order",
          redirect: "/order/orders",
          name: "Order",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "orders",
              redirect: "/order/orders",
              name: "All Order",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Order,
                },
                {
                  path: "detail/:id",
                  name: "Order Detail",
                  component: OrderDetail,
                },
              ],
            },
          ],
        },

        {
          path: "change_password",
          name: "Change Password",
          component: ChangePassword,
        },

        {
          path: "product",
          redirect: "/product/products",
          name: "Product",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "products",
              redirect: "/product/products",
              name: "",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Products,
                },
                {
                  path: "detail/:id",
                  name: "Product Details",
                  component: ProductsDetail,
                },
              ],
            },
            {
              path: "issue",
              redirect: "/product/issue",
              name: "Product Issue",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ProductIssue,
                },
                {
                  path: "detail/:id",
                  name: "Issue Details",
                  component: ProductIssueDetail,
                },
              ],
            },
          ],
        },

        {
          path: "freezer",
          redirect: "/freezer/freezers",
          name: "Freezer",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "freezers",
              redirect: "/freezer/freezers",
              name: "",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Freezers,
                },
                {
                  path: "detail/:id",
                  name: "Freezer Details",
                  component: FreezersDetail,
                },
              ],
            },
          ],
        },

        {
          path: "administrator",
          redirect: "/administrator/administrator",
          name: "Administrator",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "administrator",
              redirect: "/administrator/administrator",
              name: "",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Administrator,
                },
                {
                  path: "detail/:id",
                  name: "Administrator Details",
                  component: AdministratorDetail,
                },
              ],
            },
          ],
        },

        {
          path: "export",
          redirect: "/export/export-order",
          name: "Export",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "export-order",
              redirect: "/export/export-order",
              name: "Export Order",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ExportOrder,
                }
              ],
            },
            {
              path: "export-product",
              redirect: "/export/export-product",
              name: "Export Product",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ExportProduct,
                }
              ],
            },
            {
              path: "export-agent",
              redirect: "/export/export-agent",
              name: "Export Seller",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ExportAgent,
                }
              ],
            },
            {
              path: "export-freezer-request",
              redirect: "/export/export-freezer-request",
              name: "Export Freezer Request",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ExportFreezerRequest,
                }
              ],
            },
          ],
        },

        {
          path: "user-request-freezer",
          redirect: "/user-request-freezer/all-request",
          name: "User Request",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "all-request",
              name: "User Request Listing",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: UserRequestFreezer,
                },
                {
                  path: "detail/:id",
                  name: "User Request Freezer Details",
                  component: UserRequestFreezerDetail,
                },
              ],
            }
          ],
        },

        {
          path: "master",
          redirect: "/master/agent",
          name: "Master",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "agent",
              redirect: "/master/agent",
              name: "Master Seller",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: MasterAgent,
                },
                {
                  path: "detail/:id",
                  name: "Seller Details",
                  component: MasterAgentDetail,
                },
              ]
            },
            {
              path: "owner-freezer",
              redirect: "/master/owner-freezer",
              name: "Owner Freezer",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: OwnerFreezer,
                },
                {
                  path: "detail/:id",
                  name: "Owner Freezer Details",
                  component: OwnerFreezerDetail,
                },
              ]
            },
            {
              path: "user",
              redirect: "/master/user",
              name: "User",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: User,
                },
                {
                  path: "detail/:id",
                  name: "User Details",
                  component: UserDetail,
                },
              ],
            },
            {
              path: "delivery",
              redirect: "/master/delivery",
              name: "Delivery",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Delivery,
                },
                {
                  path: "detail/:id",
                  name: "Delivery Details",
                  component: DeliveryDetail,
                },
              ],
            },
            {
              path: "home_video",
              name: "Home Video",
              component: HomeVideo,
            },
            {
              path: "faq",
              name: "Faq",
              component: Faq,
            },
            {
              path: "contact_us",
              name: "Contact Us",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ContactUs,
                },

                {
                  path: "detail/:id",
                  name: "Contact Us Detail",
                  component: ContactUsDetail,

                },
              ],
            },
            {
              path: "menu_access",
              name: "Menu Access",
              component: MenuAccess,
            },
            {
              path: "term_condition",
              name: "Terms & Conditions",
              component: TermCondition,
            },
            {
              path: "add_menu",
              name: "Add Menu",
              component: AddMenu,
            },
            {
              path: "question",
              name: "Question",
              component: Question,
            },
            {
              path: "product_category",
              redirect: "/master/product_category",
              name: "Product Category",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: ProductCategory,
                },
                {
                  path: "detail/:id",
                  name: "Product Category Details",
                  component: ProductCategoryDetail,
                },

              ],
            },
            {
              path: "partnership-group",
              redirect: "/master/partnership-group",
              name: "Partnership Group",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: PartnershipGroup,
                },
                {
                  path: "detail/:id",
                  name: "Partnership Group Details",
                  component: PartnershipGroupDetail,
                },
              ],
            },
            {
              path: "dropdown",
              redirect: "/master/dropdown/agent-status",
              name: "Dropdown",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "agent-status",
                  name: "Seller Status",
                  component: AgentStatus,
                },
                {
                  path: "order-status",
                  name: "Order Status",
                  component: OrderStatus,
                },
                {
                  path: "product-issue-type",
                  name: "Product Issue Type",
                  component: ProductIssueType,
                },
                {
                  path: "product-status",
                  name: "Product Status",
                  component: ProductStatus,
                },
                {
                  path: "product-group",
                  name: "Product Group",
                  component: ProductGroup,
                },
                {
                  path: "notification-type",
                  name: "Notification type",
                  component: NotificationType,
                },
                {
                  path: "voucher-group",
                  name: "Voucher group",
                  component: VoucherGroup,
                },
                {
                  path: "community",
                  name: "Community",
                  component: Community,
                },
                {
                  path: "Complain-Type",
                  name: "Complain Type",
                  component: ComplaintType,
                },
                {
                  path: "Delivery-Status",
                  name: "Delivery Status",
                  component: DeliveryStatus,
                },
                {
                  path: "Delivery-Type-Status",
                  name: "Delivery Type Status",
                  component: DeliveryTypeStatus,
                },
                {
                  path: "District",
                  name: "District",
                  component: District,
                },
                {
                  path: "Villages",
                  name: "Villages",
                  component: Villages,
                },
                {
                  path: "Regencies",
                  name: "Regencies",
                  component: Regencies,
                },
                {
                  path: "Province",
                  name: "Province",
                  component: Province,
                },
                {
                  path: "Religion",
                  name: "Religion",
                  component: Religion,
                },
                {
                  path: "UserGroup",
                  name: "UserGroup",
                  component: UserGroup,
                },
                {
                  path: "UserType",
                  name: "UserType",
                  component: UserType,
                },
                {
                  path: "Product-Unit",
                  name: "Product Unit",
                  component: ProductUnit,
                },
                {
                  path: "payment-method",
                  redirect: "/master/dropdown/payment-method",
                  name: "Payment Method",
                  component: {
                    render(c) {
                      return c("router-view");
                    },
                  },
                  children: [
                    {
                      path: "",
                      name: "",
                      component: PaymentMethod,
                    },
                    {
                      path: "detail/:id",
                      name: "Payment Method Detail",
                      component: PaymentMethodDetail,
                    },
                  ],
                },
              ],
            },
            {
              path: "video-education",
              redirect: "/master/video-education",
              name: "Video Education",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: VideoEducation,
                },
                {
                  path: "video-education-category",
                  name: "Category",
                  component: VideoEducationCategory,
                },
              ],
            },
          ],
        },
        {
          path: "complaint",
          redirect: "/complaint/complaints",
          name: "Complaint",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "complaints",
              redirect: "/complaint/complaints",
              name: "Complaints",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Complaint,
                },
                {
                  path: "detail/:id",
                  name: "Complaint Details",
                  component: ComplaintDetail,
                },
              ],
            },
          ],
        },
        {
          path: "cancel",
          redirect: "/cancel/cancel_order",
          name: "Cancel",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cancel_order",
              redirect: "/cancel/cancel_order",
              name: "Cancellation Order",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: CancelOrder,
                },
                {
                  path: "detail/:id",
                  name: "Cancel Order Details",
                  component: CancelOrderDetail,
                },
              ],
            },
          ],
        },
        {
          path: "voucher",
          redirect: "/voucher/vouchers",
          name: "Voucher",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "vouchers",
              redirect: "/voucher/vouchers",
              name: "Vouchers",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Voucher,
                },
                {
                  path: "detail/:id",
                  name: "Voucher Details",
                  component: VoucherDetail,
                },
              ],
            },
          ],
        },
        {
          path: "promotion",
          redirect: "/promotion/promotions",
          name: "Promotion",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "promotions",
              redirect: "/promotion/promotions",
              name: "Promotions",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Promotion,
                },
                {
                  path: "detail/:id",
                  name: "Promotion Details",
                  component: PromotionDetail,
                },
              ],
            },
          ],
        },
        {
          path: "news",
          redirect: "/news/news",
          name: "News",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "news",
              redirect: "/news/news",
              name: "News",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: News,
                },
                {
                  path: "detail/:id",
                  name: "News Details",
                  component: NewsDetail,
                },
              ],
            },
          ],
        },
        {
          path: "partnership",
          redirect: "/partnership/partnerships",
          name: "Partnership Form",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "partnerships",
              redirect: "/partnership/partnerships",
              name: "Partnership",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: Partnership,
                },
                {
                  path: "detail/:id",
                  name: "Partnership Details",
                  component: PartnershipDetail,
                },
              ],
            },
            
          ],
        },

        {
          path: "voucher-claim",
          redirect: "/voucher-claim/vouchers",
          name: "Voucher Claim",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "vouchers",
              redirect: "/voucher-claim/vouchers",
              name: "Process QR",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "",
                  component: VoucherClaim,
                }
              ],
            },
            
          ],
        },

        
        // {
        //   path: "partnership",
        //   redirect: "/partnership/partnerships",
        //   name: "Partnership",
        //   component: {
        //     render(c) {
        //       return c("router-view");
        //     },
        //   },
        //   children: [
        //     {
        //       path: "partnerships",
        //       redirect: "/partnership/partnerships",
        //       name: "Partnerships",
        //       component: {
        //         render(c) {
        //           return c("router-view");
        //         },
        //       },
        //       children: [
        //         {
        //           path: "",
        //           name: "",
        //           component: Partnership,
        //         },
        //         {
        //           path: "detail/:id",
        //           name: "Partnership Details",
        //           component: PartnershipDetail,
        //         },
        //       ],
        //     },
            
        //   ],
        // },
        
      ],
    },
    {
      path: "/privacy",
      redirect: "/privacy/policy",
      name: "Privacy",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "policy",
          name: "Policy",
          component: Privacy,
        },
      ],
    },
    
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        // {
        //   path: '500',
        //   name: 'Page500',
        //   component: Page500
        // },
        // {
        //   path: 'login',
        //   name: 'Login',
        //   component: Login
        // },
        // {
        //   path: 'register',
        //   name: 'Register',
        //   component: Register
        // }
      ],
    },
  ];
}

if (location.host === "localhost:8080" || location.host === "localhost:8081") {
  //My localhost
  axios.defaults.baseURL = _accessApi.localhost.url;
  axios.defaults.upload_path = _accessApi.localhost.upload_path;
} else {
  //server
  axios.defaults.baseURL = _accessApi.server.url;
  axios.defaults.upload_path = _accessApi.server.upload_path;
}

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'approval', 'approval_assets', 'privacy'];
  const path = to.path.split("/");
  const authRequired = !publicPages.includes(path[1])
  const token = localStorage.getItem('token')

  //console.log(path);
  if (authRequired && token === null) {
    alert('You not eligible to access this page!')
    next('/login')
  } else if (path[1] === 'login' || path[1] === 'privacy' ) {
    next()
  } else {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    axios.post('/console/restricted', { path: to.path }).then((response) => {
      if (response.data.is_allowed === true) {
        next()
      } else {
        alert('You not eligible to access this page!')
        next('/login')
      }
    })
      .catch(error => {
        alert('Your session has been expired')
        next('/login')
      });
  }
})

// //axios.defaults.baseURL = 'http://localhost/mbs-api/public/'

Vue.use(VueAxios, axios);

